import type { FC } from "react";

import isNil from "lodash/isNil";

import Box from "@/ui/layout/Box";
import PlaceholderIllustrationSVG from "@/ui/theme/icons/illustrations/onboarding/PlaceholderIllustrationSVG";

type OnboardingIllustrationDefinition = FC<Partial<SizeDimensions>>;

enum OnboardingIllustrationSize {
  Default = "default",
  Small = "small",
}

interface IllustrationSizeConfig {
  borderRadius: number;
  dimensions: number;
}

const OnboardingIllustrationSizeConfig: Record<
  OnboardingIllustrationSize,
  IllustrationSizeConfig
> = {
  [OnboardingIllustrationSize.Default]: { borderRadius: 14, dimensions: 48 },
  [OnboardingIllustrationSize.Small]: { borderRadius: 8, dimensions: 30 },
};

enum OnboardingIllustrationName {
  Placeholder = "placeholder",
}

const OnboardingIllustrationDefinitions: Record<
  OnboardingIllustrationName,
  OnboardingIllustrationDefinition
> = {
  [OnboardingIllustrationName.Placeholder]: PlaceholderIllustrationSVG,
};

interface GetOnboardingIllustrationIconProps {
  iconName: OnboardingIllustrationName;
  size?: OnboardingIllustrationSize;
}

const getOnboardingIllustrationIcon = ({
  iconName,
  size = OnboardingIllustrationSize.Default,
}: GetOnboardingIllustrationIconProps) => {
  const Illustration = OnboardingIllustrationDefinitions[iconName];
  if (isNil(Illustration)) {
    return null;
  }
  const { borderRadius, dimensions } = OnboardingIllustrationSizeConfig[size];
  return (
    <Box
      borderRadius={borderRadius}
      height={dimensions}
      overflow="hidden"
      width={dimensions}
    >
      <Illustration height={dimensions} width={dimensions} />
    </Box>
  );
};

export {
  getOnboardingIllustrationIcon,
  OnboardingIllustrationName,
  OnboardingIllustrationSize,
  OnboardingIllustrationSizeConfig,
};
